import timg3 from '../assets/timg3.png'

export const blog3Data = [
    {
        image: timg3,
        heading: 'Dementia vs. Alzheimer\'s',
        review: 'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution.',
        name: 'Dr. Ahmad Fallata',
        date: 'June 8, 2022'
    },
]

export default blog3Data